import { IPromotion } from 'common/promotion';
import { IItinerary } from 'common/types';
import { TripType } from 'contexts/searchParams';
import IndivisualListContainer from './indivisual';
import { IInternationalContextResult } from './types';

interface IProps {
  fareType: string;
  flightResult: IInternationalContextResult;
  itinerary: IItinerary[];
  promotions: IPromotion[];
  scheduleTitles: string[];
  selectedFlightList: [string, string, string][];
  tripType: TripType;
  selectFlight: (
    index: number,
    sch: string,
    fareType: string,
    airline: string,
    labels: string[],
  ) => void;
  setMinFare: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const MultipleList = ({
  fareType,
  flightResult,
  itinerary,
  promotions,
  scheduleTitles,
  selectedFlightList,
  tripType,
  selectFlight,
  setMinFare,
}: IProps) => (
  <IndivisualListContainer
    fareType={fareType}
    flightResult={flightResult}
    itinerary={itinerary}
    promotions={promotions}
    scheduleTitles={scheduleTitles}
    selectedFlightList={selectedFlightList}
    tripType={tripType}
    selectFlight={selectFlight}
    setMinFare={setMinFare}
  />
);

export default MultipleList;
